import { useLocale } from '@mercadoni/mimic/dist/cjs/locale/contexts/LocaleContext'
import Text from '@mercadoni/sinister/dist/cjs/mystiqueText'

import EmptyBoxVector from '@/utils/vectors/EmptyBoxVector'
import { EmptyStateStyles } from './styles'

export const NoProducts = () => {
  const copy = useLocale()
  return (
    <EmptyStateStyles>
      <div className="wrapper">
        <EmptyBoxVector />
        <Text
          fontSize="14"
          fontWeight="400"
          lineHeight="17"
          appearance="black1"
        >
          {copy?.showcase?.noProductsFound}
        </Text>
      </div>
    </EmptyStateStyles>
  )
}
